<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" ref="tradeflowForm"  :label-width="80" inline :rules="ruleValidate">
          <FormItem label="身份证">
            <Input v-model="form.customId" required></Input>
          </FormItem>
          <FormItem label="账户类型">
            <Dict v-model="form.billType" dict="bill_type" :needAll="true"></Dict>
          </FormItem>
        </Form>
        <div class="toolbar">
<!--
          <Button type="primary" icon="md-trash" @click="handleDelete">导出</Button>
-->
          <Button type="primary" icon="ios-recording" @click="handleExport">导出</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <tradeflowInfo ref="tradeflowInfoRef" @handle-search="handleSearch"></tradeflowInfo>
  </div>
</template>

<script>
import tradeflowInfo from './tradeflow-info'
import { getIds } from '@/libs/util'

export default {
  name: 'tradeflow-list',
  components: {
    tradeflowInfo
  },
  data () {
    return {
      columns: [
        { title: '交易流水', key: 'flowNo' },
        { title: '交易时间', key: 'flowTime' },
        {
          title: '账单类型',
          key: 'billType',
          render: (h, params) => {
            return h('span', this.getDictVal('bill_type', params.row.billType))
          }
        },
        {
          title: '用户',
          key: 'customId',
          render: (h, params) => {
            return h('span', this.getCustomName(params.row.customId))
          }
        },
        { title: '交易类型', key: 'flowType' },
        { title: '收支方向', key: 'flowDirection' },
        { title: '付款方式', key: 'flowCard' },
        { title: '金额', key: 'money' },
        { title: '余额', key: 'balance' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false,
      ruleValidate: {
        userId: [
          { required: true, message: '身份证必填', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.tradeflowInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.tradeflowInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.tradeflowInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('tradeflow', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    handleExport () {
      if (this.form.customId) {
        this.DL('api/tradeflow/exportExcel?', this.form)
      } else {
        this.$Message.error('身份证必填')
      }
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      if (this.form.customId) {
        let param = {
          page: page,
          pageSize: pageSize,
          model: this.form,
          map: this.form.map
        }
        this.L('tradeflow', param).then(data => {
          this.tableData = data
        })
      } else {
        this.$Message.error('身份证必填')
      }
    }
  },
  mounted () {
  }
}
</script>
